
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "Modal"
})
export default class Modal extends Vue {
  @Prop(String) readonly text!: string;
  @Prop(String) readonly cancelText!: string;
  @Prop(String) readonly confirmText!: string;
  @Prop(Function) readonly onCancel!: Function;
  @Prop(Function) readonly onConfirm!: Function;
  @Prop(Boolean) readonly hideCancel!: boolean;
  @Prop(Boolean) readonly hideConfirm!: boolean;
  @Prop(Boolean) readonly showIcon!: boolean;

  visible: boolean = false;

  confirm() {
    if (this.onConfirm) {
      this.onConfirm(this);
    } else {
      this.hide();
    }
  }

  cancel() {
    if (this.onCancel) {
      this.onCancel(this);
    } else {
      this.hide();
    }
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }
}
